import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dec96a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-name mb-4" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "discount-name mb-3" }
const _hoisted_4 = { class: "row row-settings mb-5" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "settings", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 col-xxl-4 mb-3 mb-xl-0" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 col-xl-4 col-xxl-12" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = ["for"]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "col-7 col-xl-5 col-xxl-12" }
const _hoisted_24 = { class: "d-flex flex-row align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "col-7 col-xl-5 col-xxl-12" }
const _hoisted_28 = { class: "col-12 col-xxl-8" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = { class: "row mb-3" }
const _hoisted_32 = { class: "row mb-3" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = {
  key: 0,
  class: "row row-apply-on mb-4"
}
const _hoisted_40 = { class: "col-12" }
const _hoisted_41 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_42 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "checklist", -1))
const _hoisted_44 = { class: "product-filter-conditions pb-3" }
const _hoisted_45 = { class: "mt-5" }
const _hoisted_46 = { class: "fst-italic m-0" }
const _hoisted_47 = { class: "d-inline-block mt-3 pt-4 border-top border-2 border-light" }
const _hoisted_48 = { class: "text-muted ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_discount_pricelist_section = _resolveComponent("discount-pricelist-section")!
  const _component_input_date = _resolveComponent("input-date")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_i18n_input_text = _resolveComponent("i18n-input-text")!
  const _component_ButtonProductFilterPreview = _resolveComponent("ButtonProductFilterPreview")!
  const _component_ProductFilter = _resolveComponent("ProductFilter")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('shoppingCartDiscount'),
          mode: _ctx.mode,
          "help-text": _ctx.$t('descriptionDiscountsDetail'),
          "back-route": {name: _ctx.returnRoute},
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, null, 8, ["title", "mode", "help-text", "back-route", "onRefresh"]),
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.submitData,
          pageUI: _ctx.pageUI,
          buttonClass: "btn-sm"
        }, {
          content: _withCtx(({errors}) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("section", _hoisted_3, [
                  _createVNode(_component_input_text, {
                    modelValue: _ctx.discountScheme.name,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.discountScheme.name) = $event)),
                      _ctx.onFormDataChanged
                    ],
                    modelModifiers: { trim: true },
                    label: _ctx.$t('name'),
                    name: "name",
                    rules: "required|max:100",
                    errors: errors
                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h2", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(_toDisplayString(_ctx.$t('discountSettings')), 1)
                      ])
                    ]),
                    _createVNode(_component_MultilingualSwitcher, {
                      class: "col-8",
                      errors: errors,
                      "active-language": _ctx.activeLanguage,
                      mb: 2,
                      onUpdateActiveLanguage: _cache[1] || (_cache[1] = (newValue) => _ctx.activeLanguage = newValue)
                    }, null, 8, ["errors", "active-language"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_discount_pricelist_section, {
                            class: "discount-amount mb-3",
                            title: _ctx.$t('discountAmount'),
                            icon: "euro"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("label", {
                                    class: "mb-2",
                                    for: _ctx.$t('amount')
                                  }, _toDisplayString(_ctx.$t('amount')), 9, _hoisted_17),
                                  _createVNode(_component_input_number, {
                                    modelValue: _ctx.discountScheme.discount_value,
                                    "onUpdate:modelValue": [
                                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.discountScheme.discount_value) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    name: _ctx.$t('amount'),
                                    mode: "group-start",
                                    min: 0,
                                    errors: errors
                                  }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("label", {
                                    class: "mb-2",
                                    for: _ctx.$t('type')
                                  }, _toDisplayString(_ctx.$t('type')), 9, _hoisted_19),
                                  _createVNode(_component_input_select, {
                                    modelValue: _ctx.discountScheme.type_code,
                                    "onUpdate:modelValue": [
                                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.discountScheme.type_code) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    name: _ctx.$t('type'),
                                    options: _ctx.discountTypeOptions,
                                    rules: "required",
                                    errors: errors
                                  }, null, 8, ["modelValue", "name", "options", "errors", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("label", {
                                    class: "mb-1",
                                    for: _ctx.$t('maximum')
                                  }, _toDisplayString(_ctx.$t('maximum')), 9, _hoisted_22),
                                  _createVNode(_component_input_number, {
                                    modelValue: _ctx.discountScheme.max_allowed_discount_amount,
                                    "onUpdate:modelValue": [
                                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.discountScheme.max_allowed_discount_amount) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    name: _ctx.$t('maximum'),
                                    mode: "group-start",
                                    "addon-text": "€",
                                    errors: errors
                                  }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
                                ], 512), [
                                  [_vShow, _ctx.discountScheme.type_code === 'PERCENTAGE']
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_discount_pricelist_section, {
                            class: "discount-period mb-3",
                            title: _ctx.$t('period'),
                            icon: "date_range"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_input_date, {
                                  label: _ctx.$t('begin'),
                                  placeholder: "DD-MM-JJJJ",
                                  name: _ctx.$t('begin'),
                                  modelValue: _ctx.discountScheme.begin_date,
                                  "onUpdate:modelValue": [
                                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.discountScheme.begin_date) = $event)),
                                    _ctx.onFormDataChanged
                                  ],
                                  rules: "required",
                                  class: "me-3",
                                  errors: errors
                                }, null, 8, ["label", "name", "modelValue", "errors", "onUpdate:modelValue"]),
                                _createVNode(_component_input_date, {
                                  label: _ctx.$t('end'),
                                  placeholder: "DD-MM-JJJJ",
                                  name: _ctx.$t('end'),
                                  modelValue: _ctx.discountScheme.end_date,
                                  "onUpdate:modelValue": [
                                    _cache[6] || (_cache[6] = ($event: any) => ((_ctx.discountScheme.end_date) = $event)),
                                    _ctx.onFormDataChanged
                                  ],
                                  rules: "check_date:@begin,@end",
                                  class: "me-3",
                                  errors: errors
                                }, null, 8, ["label", "name", "modelValue", "errors", "onUpdate:modelValue"]),
                                (_ctx.discountScheme.end_date)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.removeDiscountSchemePeriod()), ["prevent"])),
                                      class: "btn btn-icon btn-sm mb-3"
                                    }, _hoisted_26))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_discount_pricelist_section, {
                            class: "discount-client-group mb-3",
                            title: _ctx.$t('clientGroup'),
                            icon: "group"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_input_select, {
                                modelValue: _ctx.discountScheme.client_group_code,
                                "onUpdate:modelValue": [
                                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.discountScheme.client_group_code) = $event)),
                                  _ctx.onFormDataChanged
                                ],
                                name: _ctx.$t('clientGroup'),
                                options: _ctx.clientGroups,
                                errors: errors
                              }, null, 8, ["modelValue", "name", "options", "errors", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_discount_pricelist_section, {
                            class: "discount-message pb-2 mb-3",
                            title: _ctx.$t('shoppingCartDiscount'),
                            icon: "chat"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_input_text, {
                                  modelValue: _ctx.discountScheme.promo_code,
                                  "onUpdate:modelValue": [
                                    _cache[9] || (_cache[9] = ($event: any) => ((_ctx.discountScheme.promo_code) = $event)),
                                    _ctx.onFormDataChanged
                                  ],
                                  modelModifiers: { trim: true },
                                  label: _ctx.$t('promoCode'),
                                  name: "promo_code",
                                  rules: "required|max:100",
                                  errors: errors
                                }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_input_checkbox_boolean, {
                                    modelValue: _ctx.discountScheme.is_promo_cumulative_with_discounts,
                                    "onUpdate:modelValue": [
                                      _cache[10] || (_cache[10] = ($event: any) => ((_ctx.discountScheme.is_promo_cumulative_with_discounts) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    label: _ctx.$t('isCumulativeWithDiscounts'),
                                    name: "is_promo_cumulative_with_discounts",
                                    errors: errors
                                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_input_number, {
                                    modelValue: _ctx.discountScheme.minimum_purchase_amount,
                                    "onUpdate:modelValue": [
                                      _cache[11] || (_cache[11] = ($event: any) => ((_ctx.discountScheme.minimum_purchase_amount) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    modelModifiers: { trim: true },
                                    label: _ctx.$t('minimumPurchaseAmount'),
                                    name: "minimum_purchase_amount",
                                    mode: "group-start",
                                    "addon-text": "€",
                                    rules: "required",
                                    errors: errors
                                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_component_i18n_input_text, {
                                  name: "discount_promo_message",
                                  data: _ctx.discountScheme.promo_message,
                                  label: _ctx.$t('promoMessage'),
                                  "active-language": _ctx.activeLanguage,
                                  errors: errors,
                                  "onUpdate:modelValue": _ctx.promoMessageUpdated
                                }, null, 8, ["data", "label", "active-language", "errors", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_input_number, {
                                    modelValue: _ctx.discountScheme.promo_max_usage,
                                    "onUpdate:modelValue": [
                                      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.discountScheme.promo_max_usage) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    modelModifiers: { trim: true },
                                    label: _ctx.$t('promoCodeMaxUses'),
                                    name: "promo_max_usage",
                                    errors: errors
                                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_input_number, {
                                    modelValue: _ctx.discountScheme.promo_max_usage_per_user,
                                    "onUpdate:modelValue": [
                                      _cache[13] || (_cache[13] = ($event: any) => ((_ctx.discountScheme.promo_max_usage_per_user) = $event)),
                                      _ctx.onFormDataChanged
                                    ],
                                    modelModifiers: { trim: true },
                                    label: _ctx.$t('promoCodeMaxUsesPerUser'),
                                    name: "promo_max_usage_per_user",
                                    errors: errors
                                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.discountScheme.product_filter !== null && _ctx.discountScheme.product_filter !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("h2", _hoisted_42, [
                        _hoisted_43,
                        _createTextVNode(_toDisplayString(_ctx.$t('applyPromoCodeOnFollowingProducts')) + " ", 1),
                        (_ctx.discountScheme.product_filter?.code)
                          ? (_openBlock(), _createBlock(_component_ButtonProductFilterPreview, {
                              key: 0,
                              "product-filter-code": _ctx.discountScheme.product_filter?.code,
                              class: "ms-3"
                            }, null, 8, ["product-filter-code"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_ProductFilter, {
                          "is-all-products-filter-allowed": true,
                          modelValue: _ctx.discountScheme.product_filter,
                          "onUpdate:modelValue": [
                            _cache[14] || (_cache[14] = ($event: any) => ((_ctx.discountScheme.product_filter) = $event)),
                            _ctx.onFormDataChanged
                          ],
                          errors: errors
                        }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"]),
                        _createElementVNode("footer", _hoisted_45, [
                          _createVNode(_component_input_checkbox_boolean, {
                            modelValue: _ctx.discountScheme.exclude_prescription_required,
                            "onUpdate:modelValue": [
                              _cache[15] || (_cache[15] = ($event: any) => ((_ctx.discountScheme.exclude_prescription_required) = $event)),
                              _ctx.onFormDataChanged
                            ],
                            label: _ctx.$t('excludeNonPrescriptionDrugs'),
                            name: _ctx.$t('excludeNonPrescriptionDrugs'),
                            errors: errors,
                            class: "mb-2"
                          }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                          _createElementVNode("p", _hoisted_46, _toDisplayString(`${_ctx.$t('remark')}: ${_ctx.$t('discountsNeverAppliedToPrescriptionDrugs')}.`), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_input_select, {
                modelValue: _ctx.discountScheme.status_code,
                "onUpdate:modelValue": [
                  _cache[16] || (_cache[16] = ($event: any) => ((_ctx.discountScheme.status_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                name: "status",
                selectText: _ctx.$t('selectText'),
                options: _ctx.statusOptions,
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "selectText", "options", "errors", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"]),
        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('cachingDelayMinutes', [5])), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}